import { type FC } from "react";
import { Users, Clock } from "lucide-react";
import { Button } from "@/shared/components/ui/button";

interface ContactStatusBadgeProps {
  isAccountOwner: boolean;
  acceptedInvitation: boolean;
  pendingInvitation: boolean;
  isInvited: boolean;
  onResendInvitation?: () => void;
  isResendingInvitation?: boolean;
  className?: string;
}

export const ContactStatusBadge: FC<ContactStatusBadgeProps> = ({
  isAccountOwner,
  acceptedInvitation,
  pendingInvitation,
  isInvited,
  onResendInvitation,
  isResendingInvitation = false,
  className = "",
}) => {
  if (isAccountOwner) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="text-sm font-normal text-secondary">Account Owner</span>
      </div>
    );
  } else if (acceptedInvitation) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Users className="h-4 w-4 text-brand" />
        <span className="text-sm font-normal text-brand">Active</span>
      </div>
    );
  } else if (pendingInvitation || isInvited) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Clock className="h-4 w-4 text-secondary" />
        <span className="text-sm font-normal text-secondary">
          Invited
          {onResendInvitation && (
            <>
              ,{" "}
              <Button
                variant="link"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  onResendInvitation();
                }}
                disabled={isResendingInvitation}
                className="h-auto p-0 text-sm font-normal underline text-brand"
              >
                {isResendingInvitation ? "resending..." : "resend"}
              </Button>
            </>
          )}
        </span>
      </div>
    );
  } else {
    return null;
  }
};
